import React from 'react'
import './CountDownSpecial.css'
import {isPC} from '../../../../utils'

class CountDownSpecial extends React.Component  {
    constructor(props) {
        super(props)
        this.state = {
            useStatus: 0,
            deadline: 0,
            price: 0,
            show: false
        }
    }

    componentDidMount() {
        this.beginCountdown(this.props.endTime)
    }

    // 开启倒计时
    beginCountdown(endTime) {
        let getDuration = () => (endTime - parseInt(new Date().getTime() / 1000, 10))
        let getMs = () => 9 -  parseInt(~~(new Date().getTime() / 1000).toString().split(".")[1] / 100, 10)
        this.setState({show: true})

        let _that = this
        this.timer = requestAnimationFrame(function fn() {
            let duration = getDuration()
            let ms = getMs()
            if (duration < 0) {
                cancelAnimationFrame(_that.timer)
            } else {
                if (_that.refs.limitMs && _that.refs.limitMs !== undefined && ms !== undefined) {
                    _that.refs.limitMs.innerHTML = ms + '0'
                }

                let tmp = duration
                let ss = (tmp % 60).toFixed(0)
                if (ss !== undefined && _that.refs.limitSs && _that.refs.limitSs !== undefined) {
                    if (ss.length < 2) {
                        _that.refs.limitSs.innerHTML = '0' + ss
                    } else {
                        _that.refs.limitSs.innerHTML = ss
                    }
                }

                tmp = (tmp - ss) / 60
                let mm = (tmp % 60).toFixed(0)
                if (mm !== undefined && _that.refs.limitMm && _that.refs.limitMm !== undefined ) {
                    if (mm.length < 2) {
                        _that.refs.limitMm.innerHTML = '0' + mm
                    } else {
                        _that.refs.limitMm.innerHTML = mm
                    }
                }

                tmp = (tmp - mm) / 60
                let dd = (tmp - tmp % 24) / 24
                let hh = (tmp % 24 + dd * 24).toFixed(0)
                if (_that.refs.limitHh && _that.refs.limitHh !== undefined && hh !== undefined) {
                    if (hh.length < 2) {
                        _that.refs.limitHh.innerHTML = '0' + hh
                    } else {
                        _that.refs.limitHh.innerHTML = hh
                    }
                }

                _that.timer = requestAnimationFrame(fn)
            }
        })
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer)
        }
    }

    render() {
        if (!this.state.show) {
            return null
        }
        return(
            <div className="coupon_countdownSpecial">
                <div className="limit-bar-time">
                    <span className="limit-bar-time__num" style={{lineHeight: isPC() ? '14px' : '16px'}} ref="limitHh"/>
                    <i style={{fontWeight: 500}}>:</i>
                    <span className="limit-bar-time__point"/>

                    <span className="limit-bar-time__num" style={{lineHeight: isPC() ? '14px' : '16px'}} ref="limitMm"/>
                    <i style={{fontWeight: 500}}>:</i>
                    <span className="limit-bar-time__point"/>

                    <span className="limit-bar-time__num" style={{lineHeight: isPC() ? '14px' : '16px'}} ref="limitSs"/>
                    <i style={{fontWeight: 500}}>:</i>
                    <span className="limit-bar-time__point"/>

                    <span className="limit-bar-time__num" style={{lineHeight: isPC() ? '14px' : '16px'}} ref="limitMs"/>
                    <i/>
                </div>
            </div>
        )
    }
}

export default CountDownSpecial



// WEBPACK FOOTER //
// ./src/components/activity/FloatCouponSpecial/CountDownSpecial/CountDownSpecial.js